import { IAnnualReportAccordionsData } from '../../interfaces/IAnnualReportAccordionsData.interface';

export interface INotesDelegate {
    outputtedAccordionsData(accordionsData: IAnnualReportAccordionsData, dataWasReset: boolean): void;
    outputtedAccordionsDefaultData(accordionsData: IAnnualReportAccordionsData): void;
    fireResetConfirmationMessage(): void;
}
